import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { StorageType } from 'mbs-ui-shared@models';

@Pipe({
  name: 'storageDisplayName',
  standalone: true,
  pure: true
})
export class StorageDisplayNamePipe implements PipeTransform {
  public storageTypeDisplayName = {
    [StorageType.Alibaba]: this.i18nPipe.transform('shared:storages.list.alibaba.name'),
    [StorageType.AmazonS3]: this.i18nPipe.transform('shared:storages.list.amazonS3Glacier.name'),
    [StorageType.AmazonS3Apps]: this.i18nPipe.transform('shared:storages.list.amazonS3.name'),
    [StorageType.AmazonS3Chinese]: this.i18nPipe.transform('shared:storages.list.amazonS3Chinese.name'),
    [StorageType.Aruba]: this.i18nPipe.transform('shared:storages.list.aruba.name'),
    [StorageType.Azure]: this.i18nPipe.transform('shared:storages.list.azure.name'),
    [StorageType.AzureFile]: this.i18nPipe.transform('shared:storages.list.azureFile.name'),
    [StorageType.AzureVM]: this.i18nPipe.transform('shared:storages.list.azureVM.name'),
    [StorageType.BackblazeB2]: this.i18nPipe.transform('shared:storages.list.backblaze.name'),
    [StorageType.CblWasabi]: this.i18nPipe.transform('shared:storages.list.cblWasabi.name'),
    [StorageType.CenturyLink]: this.i18nPipe.transform('shared:storages.list.centuryLink.name'),
    [StorageType.Cloudian]: this.i18nPipe.transform('shared:storages.list.cloudian.name'),
    [StorageType.CloudWatt]: this.i18nPipe.transform('shared:storages.list.cloudWatt.name'),
    [StorageType.Dedup]: this.i18nPipe.transform('shared:storages.list.dedup.name'),
    [StorageType.DreamObjects]: this.i18nPipe.transform('shared:storages.list.dreamObjects.name'),
    [StorageType.EasyStorage]: this.i18nPipe.transform('shared:storages.list.easyStorage.name'),
    [StorageType.FTP]: this.i18nPipe.transform('shared:storages.list.FTP.name'),
    ...this.convertSimilarDisplayName([StorageType.Google, StorageType.GoogleCloud], 'googleCloud'),
    ...this.convertSimilarDisplayName([StorageType.GoogleDrive, StorageType.GoogleDriveOAuth], 'googleDrive'),
    [StorageType.HostEurope]: this.i18nPipe.transform('shared:storages.list.hostEurope.name'),
    [StorageType.HPCloud]: this.i18nPipe.transform('shared:storages.list.HPCloud.name'),
    [StorageType.HPHelion]: this.i18nPipe.transform('shared:storages.list.HPHellion.name'),
    [StorageType.IDCFrontier]: this.i18nPipe.transform('shared:storages.list.IDCFrontier.name'),
    [StorageType.LeoNovusS3]: this.i18nPipe.transform('shared:storages.list.leoNovusS3.name'),
    [StorageType.LocalFS]: this.i18nPipe.transform('shared:storages.list.localFS.name'),
    [StorageType.Minio]: this.i18nPipe.transform('shared:storages.list.minio.name'),
    [StorageType.NetApp]: this.i18nPipe.transform('shared:storages.list.netApp.name'),
    [StorageType.NiftyCloud]: this.i18nPipe.transform('shared:storages.list.niftyCloud.name'),
    [StorageType.OpenStack]: this.i18nPipe.transform('shared:storages.list.openStack.name'),
    [StorageType.OracleCloud]: this.i18nPipe.transform('shared:storages.list.oracleCloud.name'),
    [StorageType.S3Compatible]: this.i18nPipe.transform('shared:storages.list.S3Compatible.name'),
    [StorageType.ScalityCloud]: this.i18nPipe.transform('shared:storages.list.scalityCloud.name'),
    [StorageType.Seeweb]: this.i18nPipe.transform('shared:storages.list.seeweb.name'),
    [StorageType.SFTP]: this.i18nPipe.transform('shared:storages.list.SFTP.name'),
    [StorageType.SwiftStack]: this.i18nPipe.transform('shared:storages.list.swiftStack.name'),
    [StorageType.SwiftStackS3]: this.i18nPipe.transform('shared:storages.list.swiftStackS3.name'),
    [StorageType.ThinkOn]: this.i18nPipe.transform('shared:storages.list.thinkOn.name'),
    [StorageType.UbAmazonS3]: this.i18nPipe.transform('shared:storages.list.ubAmazonS3.name'),
    [StorageType.VCloudAirEMC]: this.i18nPipe.transform('shared:storages.list.VCloudAirEMC.name'),
    [StorageType.VCloudAirGoogle]: this.i18nPipe.transform('shared:storages.list.VCloudAirGoogle.name'),
    [StorageType.Wasabi]: this.i18nPipe.transform('shared:storages.list.wasabi.name')
    // ... add missing storages here
  };

  constructor(private i18nPipe: I18NextPipe) {}

  transform(storageType: StorageType): string {
    return this.storageTypeDisplayName[storageType] || storageType?.toString();
  }

  private convertSimilarDisplayName(groups: StorageType[], key: string): { [p: string]: string } {
    return Object.fromEntries(
      [groups].flatMap((group) => group.map((type) => [type, this.i18nPipe.transform(`shared:storages.list.${key}.name`)]))
    );
  }
}
